/* eslint-disable max-len */
import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { Button } from "./style";
import "./modal.scss";

const PopupDelete = ({ toggle, isOpen, elementToDelete, type, handleDelete }) => {
  function getMessage(typeOfElement) {
    switch (typeOfElement) {
      case "component":
        return {
          message: (
            <>
              ¿Está seguro que desea borrar este
              <span style={{ fontWeight: "bold" }}> componente </span>?
            </>
          ),
        };
      case "unit":
        return {
          message: (
            <>
              Está por borrar toda la
              <span style={{ fontWeight: "bold" }}> unidad </span>y los componentes de la misma
            </>
          ),
        };
      case "course":
        return {
          message: (
            <>
              Está por borrar este
              <span style={{ fontWeight: "bold" }}> curso. </span> Solo es posible si no hay inscriptos sea cual sea su estado.
            </>
          ),
        };
      default:
        // Provide a default message or handle the default case accordingly
        return { message: "Mensaje por defecto" };
    }
  }

  const handleClickDelete = (id) => {
    handleDelete(id);
    toggle();
  };
  return (
    <div>
      <Modal isOpen={isOpen} centered size="sm">
        <ModalHeader className="border-0 height-50" toggle={toggle} />
        <ModalBody>
          <>
            <FontAwesomeIcon icon={faWarning} color="red" size="3x" />
            <div className="p-2 w-100 d-flex flex-column justify-content-center align-items-center">
              <p
                className="d-block badge-pills h-50 w-100 justify-content-center text-center py-2"
                style={{ fontSize: "14px", fontWeight: "normal", fontFamily: "Nunito" }}
              >
                {getMessage(type).message}
              </p>
              <p className="badge-pills h-50 w-100 justify-content-center text-center py-2" style={{ fontSize: "14px", fontWeight: "bold", fontFamily: "Nunito" }}>
                ESTA ACCION ES IRREVERSIBLE
              </p>
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0">
          <Button className="btn px-2 py-1 text-center" onClick={toggle} type="button">
            Cancelar
          </Button>
          <Button
            className="btn px-2 py-1 text-center"
            style={{ backgroundColor: "red", color: "white" }}
            onClick={() => handleClickDelete(elementToDelete.id)}
            type="button"
          >
            Borrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PopupDelete;
